/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite, TweenLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {ElGordosRevengeGameAssets} from "../ElGordosRevengeGameAssets";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";
import {IBetWayWinData} from "../server/data/IElGordosRevengeData";
import {ElGordosRevengeReelView} from "../reels/ElGordosRevengeReelView";
import {ElGordosRevengeReelController} from "../reels/ElGordosRevengeReelController";
import {ElGordosRevengeGameConfig} from "../ElGordosRevengeGameConfig";

export class WinEffect extends PIXI.Sprite {

    private _effect:TimelineSprite;
    private _overlay:PIXI.Sprite;

    constructor(textures:PIXI.Texture[], anchor:PIXI.Point = new PIXI.Point(0.5, 0.5)) {
        super();
        this._overlay = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("individualWin/yellowOverlay")[0]);
        this._overlay.anchor.set(0.5, 0.5);
        this._overlay.blendMode = PIXI.BLEND_MODES.ADD;
        this._overlay.alpha = 0;
        this.addChild(this._overlay);

        this._effect = new TimelineSprite(textures);
        this._effect.anchor.set(anchor.x, anchor.y);
        this._effect.hide();
        this.addChild(this._effect);
    }

    public playHintEffect():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            this._effect.alpha = 0.6;
        });
        tl.add(this.playWinEffect());
        return tl;
    }

    public playWinEffect():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            TweenLite.to(this._overlay, 0.16, {alpha : 0.04}),
            this._effect.getAnimationAutoShowHide(true, true)
        ]);
        tl.add(TweenLite.to(this._overlay, 0.066, {alpha : 0}), 0.477);
        return tl;
    }
}

export class IndividualWinText extends PIXI.Container {

    private _maxWayWidth:number = 140;

    constructor(multipliedAmount:number, multiplier:number, way:number) {
        super();
        // multipliedAmount = 100000000;
        // way = 11216;
        const winNumberContainer = new PIXI.Container();
        this.addChild(winNumberContainer);
        winNumberContainer.y = -12

        let winTotalWidth = 0;
        const winNumber = new PIXI.BitmapText(`${SlotGame.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(multipliedAmount / multiplier, 2))}`, {
            fontName : ElGordosRevengeGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 6,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        winNumber.letterSpacing = -20;
        (<PIXI.Point>winNumber.anchor).set(0, 2.2);
        winNumberContainer.addChild(winNumber);
        winNumber.updateTransform();
        winTotalWidth += winNumber.textWidth;

        if(multiplier > 1) {
            const multiplierText = new PIXI.BitmapText(`x${multiplier}`, {
                fontName : ElGordosRevengeGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
                fontSize : 16,
                tint : ElGordosRevengeGameConfig.MULTIPLIER_TEXT_TINT
            });
            (<PIXI.Point>multiplierText.anchor).set(1, 1.5);
            multiplierText.letterSpacing = -10;
            winNumberContainer.addChild(multiplierText);
            multiplierText.updateTransform();
            multiplierText.scale.y = 0.7;
            winTotalWidth += multiplierText.textWidth + 2;
            multiplierText.x = winTotalWidth * 0.5;
        }
        winNumber.x = -winTotalWidth * 0.5;

        if(winTotalWidth > this._maxWayWidth) {
            const winScale = MathHelper.roundToDecimals(this._maxWayWidth / winTotalWidth, 2);
            winNumberContainer.scale.set(winScale);
        }

        const waysContainer = new PIXI.Container();
        this.addChild(waysContainer);
        waysContainer.y = 26;

        const waysWonNumber = new PIXI.BitmapText(way.toString(), {
            fontName : ElGordosRevengeGameAssets.BITMAP_FONT_WAYS,
            fontSize : 10,
            tint : ElGordosRevengeGameConfig.WAYS_NUMBER_TINT
        });
        (<PIXI.Point>waysWonNumber.anchor).set(0, 1.38);
        waysWonNumber.letterSpacing = -12;
        waysContainer.addChild(waysWonNumber);

        const textureName:string = way === 1 ? 'totalways/way' : 'totalways/ways';
        const waysWonText = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures(textureName)[0]);
        waysWonText.anchor.set(1, 0.5);
        waysWonText.scale.set(0.5);
        waysWonText.tint = ElGordosRevengeGameConfig.WAYS_TEXT_TINT;
        waysContainer.addChild(waysWonText);

        waysWonNumber.updateTransform();
        const waysTotalWidth:number = waysWonNumber.textWidth + waysWonText.width + 4;
        waysWonNumber.x = -waysTotalWidth / 2;
        waysWonText.x = waysTotalWidth / 2;
        if(waysTotalWidth > this._maxWayWidth) {
            const waysScale = MathHelper.roundToDecimals(this._maxWayWidth / waysTotalWidth, 2);
            waysContainer.scale.set(waysScale);
        }
    }
}

export class EGRWinView {

    private _layer:StageLayer;
    private _individualWinText:IndividualWinText | null;
    private _individualWinTextTl:TweenLite | null;

    private _isToggling:boolean = false;

    constructor() {
        this._layer = ElGordosRevengeLayers.getLayer(Layers.WIN_TEXTS)!;
    }

    public getIndividualTextureName(winRatio:number):string {
        const winRatios = ElGordosRevengeGameConfig.getWinRatioConfig(ElGordosRevenge.model.parsedGameData.mode);
        const base = `animMain/WinHighlight/individual`
        if(winRatio >= winRatios[3].ratio) {
            return `${base}Large/individualLarge_`;
        }
        if(winRatio >= winRatios[2].ratio) {
            return `${base}Mid/individualMid_`;
        }
        return `${base}Small/individualSmall_`;
    }

    public getInitialTextureName(winRatio:number):string {
        const winRatios = ElGordosRevengeGameConfig.getWinRatioConfig(ElGordosRevenge.model.parsedGameData.mode);
        const base = `animMain/InitialWin/initial`
        if(winRatio >= winRatios[3].ratio) {
            return `${base}Large_trigger/initialLarge_trigger_`;
        }
        if(winRatio >= winRatios[2].ratio) {
            return `${base}Mid_trigger/initialMid_trigger_`;
        }
        return `${base}Tiny_trigger/initialTiny_trigger_`;
    }

    public playInitialWinText(position:PIXI.Point, winData:IBetWayWinData):void {
        const winText = new IndividualWinText(winData.multipliedAmount, winData.multiplier, winData.numberOfCombinations);
        winText.position.set(position.x, position.y);
        const winTextTl = new TimelineLite();
        winTextTl.add(() => {
            this._layer.addChild(winText);
        });
        winTextTl.add([
            TweenLite.to(winText, 1, {y : position.y - 100}),
            TweenLite.to(winText, 0.8, {alpha : 0, delay : 0.2})
        ], `+=0.3`);
        winTextTl.add(() => {
            this._layer.removeChild(winText);
            winText.destroy();
        });
    }

    public playIndividualWinText(position:PIXI.Point, winData:IBetWayWinData):void {
        this.removeToggleWinText();
        if(!this._isToggling) {
            return;
        }
        this._individualWinText = new IndividualWinText(winData.multipliedAmount, winData.multiplier, winData.numberOfCombinations);
        this._individualWinText.position.set(position.x, position.y);
        this._individualWinText.alpha = 0;
        this._layer.addChild(this._individualWinText!);
        this._individualWinTextTl = TweenLite.to(this._individualWinText, 0.1, {alpha : 1});
    }

    public startToggle():void {
        this._isToggling = true;
    }

    public stopToggle():void {
        this._isToggling = false;
        this.removeToggleWinText();
    }

    public removeToggleWinText():void {
        if(this._individualWinTextTl && this._individualWinTextTl.isActive()) {
            this._individualWinTextTl.progress(1);
        }
        this._individualWinTextTl = null;

        if(this._individualWinText) {
            if(this._individualWinText.parent) {
                this._individualWinText.parent.removeChild(this._individualWinText);
            }
            this._individualWinText.destroy();
            this._individualWinText = null;
        }
    }

    public getWinTextPosition(reelWinPositions:boolean[][]):PIXI.Point {
        for(let reelId = reelWinPositions.length - 1; reelId >= 0; reelId--) {
            if(ElGordosRevenge.model.parsedGameData.evaluatedArea[2][0] === "WXN") {
                continue;
            }
            for(let symId = 0; symId < ElGordosRevengeReelController.SYMBOLS_NUM_IN_DATA[2][2]; symId++) {
                if(reelWinPositions[reelId][symId] && !ElGordosRevenge.model.parsedGameData.reels[reelId][symId + 1].includes("W") && !ElGordosRevenge.model.parsedGameData.reels[reelId][symId + 1].includes("S")) {
                    return new PIXI.Point(reelId, symId);
                }
            }
        }
        return new PIXI.Point(0, reelWinPositions[0].indexOf(true));
    }

    public getWinEffectAnimation(reelId:number, symId:number, isToggle:boolean, textures:PIXI.Texture[], anchor?:PIXI.Point):TimelineLite {
        const effect = this.getWinEffect(ElGordosRevengeReelView.getSymbolGlobalPosition(reelId, symId), textures, anchor);
        const tl = new TimelineLite();
        tl.add(() => {
            if(isToggle && this._isToggling) {
                ElGordosRevengeLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(effect);
            }
        });
        tl.add(effect.playWinEffect());
        tl.add(() => {
            this.removeWinEffect(effect);
        });
        return tl;
    }

    public getWinEffect(position:PIXI.Point, textures:PIXI.Texture[], anchor?:PIXI.Point):WinEffect {
        const effect = new WinEffect(textures, anchor);
        effect.position.set(position.x, position.y);

        return effect;
    }

    public removeWinEffect(winEffect:WinEffect):void {
        if(winEffect.parent) {
            winEffect.parent.removeChild(winEffect);
        }
        winEffect.destroy();
    }
}